// =================== Staging Server =====================

module.exports = {
  ivp_clientID: "ivp",
  // ivp_clientID: "integration",
  ivp_client_secret: "abAlKmOvSxQd7kaJnaa9tRy4EziVhcBD",
  // ivp_client_secret: "2vkBysrxQWNC8wTu37XsCGmeimZpaN9E",
  // arms_clientID: "raas",
  arms_clientID: "forms",
  arms_client_secret: "z8ARUWaQv6h4IGUk1Y1SW6O4KDnJkCUA",
  vlab_clientID: "vlab",
  vlab_client_secret: "8erxj49QhbSVmTLGfrnpQ7fgMtwy1EwS",
  quiz_clientID: "quiz",
  quiz_client_secret: "7uCdVMu8AXXCTvy67sISTkakZfHCXXsf",
  lms_clientID: "elearning",
  lms_client_secret: "JatGR13Ou8ymY3Ejzwpn1NMFSxz2rTMH",
  infosec_awareness_lms_clientID: "infosec",
  infosec_awareness_client_secret: "2115f999-6d51-4d6d-8cae-70896ec3f9c1",
  staySafeOnline_clientID: "staysafeonline",
  staySafeOnline_client_secret: "fa7cee81-86ac-4615-94e1-d2eef3737961",
  ciso_clientID: "ciso",
  ciso_client_secret: "OzQ9SZKG5omf2EKuS3KEg0sOWHQtF1tR",
  ciso_lms_clientID: "ciso_lms",
  ciso_lms_client_secret: "QASOoSbvJuBpFPepHf5c34KARxGPrOlK",
  ctf_clientID: "ctf",
  ctf_client_secret: "8ZTolM1nUQn1j8cbVPwJ5mhAOdqQj2hv",
  digitalNagrik_clientID: "digitalnagriks",
  digitalNagrik_client_secret: "uD1NG9WXmdqgsfgI1cvbdZJg31DHN4KC",
  pmu_clientID: "pmu",
  pmu_client_secret: "QDdMJomxXJwllK3Kv9vvjUi4bfhIlcZm",
  // cyberkid_clientID: "cyberkid",
  cyberkid_clientID: "elearning",
  cyberkid_client_secret: "ya9au4act67S1OFefd891o5UbcENLy07",
  virtual_conference_clientID: "Virtual Conference",
  Naagriks_clientId: "naagariks",
  MalwareAnalysis_clientId: "malwareanalysis",
  Integrated_clientId: "integration",
  ivpConference_clientID: "ivp", //while pushing to git
  glams_clientID: "glamsstaging", //while pushing to git
  virtual_conference_clientId: "vconference",
  gpu_clientID: "gpu",
};

// ======================= Production ==========================

// module.exports = {
//   ivp_clientID: "ivp",
//   ivp_client_secret: "abAlKmOvSxQd7kaJnaa9tRy4EziVhcBD",
//   // ivp_client_secret: "2vkBysrxQWNC8wTu37XsCGmeimZpaN9E",
//   arms_clientID: "raas",
//   arms_client_secret: "z8ARUWaQv6h4IGUk1Y1SW6O4KDnJkCUA",
//   vlab_clientID: "vlab",
//   vlab_client_secret: "3hvcDvZ9eNWpZo82bHIOTCSZiIjdECrf",
//   quiz_clientID: "quiz",
//   quiz_client_secret: "7uCdVMu8AXXCTvy67sISTkakZfHCXXsf",
//   lms_clientID: "elearning",
//   lms_client_secret: "JatGR13Ou8ymY3Ejzwpn1NMFSxz2rTMH",
//   infosec_awareness_lms_clientID: "infosec",
//   infosec_awareness_client_secret: "2115f999-6d51-4d6d-8cae-70896ec3f9c1",
//   staySafeOnline_clientID: "staysafeonline",
//   staySafeOnline_client_secret: "fa7cee81-86ac-4615-94e1-d2eef3737961",
//   ciso_clientID: "ciso",
//   ciso_client_secret: "mRQu2TNfFw0lYuOADGfjcDPBpdmtaiRw",
//   ciso_lms_clientID: "ciso_lms",
//   ciso_lms_client_secret: "QASOoSbvJuBpFPepHf5c34KARxGPrOlK",
// };

// ======================= Local server (dhananjay.hyderabad.cdac.in) ==========================

// module.exports = {
//   ivp_clientID: "ivp",
//   ivp_client_secret: "abAlKmOvSxQd7kaJnaa9tRy4EziVhcBD",
//   // ivp_client_secret: "2vkBysrxQWNC8wTu37XsCGmeimZpaN9E",
//   // ivp_client_secret: "419dd71a-f66f-4110-8e5a-8d494031f15f",
//   arms_clientID: "raas",
//   arms_client_secret: "YFdVH6lXqnZ3mjegB2K6K9dmtNPIQroJ",
//   vlab_clientID: "vlab",
//   // vlab_client_secret: "3e4eb111-25a9-4fe0-89ca-0fd42ea19815",
//   vlab_client_secret: "9ONFmnexsB0ChTlk6BTfaWc3m3X2DksG",
//   // quiz_clientID: "quiz",
//   // quiz_client_secret: "opEVb7Xw07fmgbtfb1LPNEH7Yf3Jwhyu",
//   quiz_clientID: "assessment",
//   quiz_client_secret: "hv5c2vXZvM1Z3vGE4JpvYR4UeNeEXRkn",
//   lms_clientID: "elearning",
//   lms_client_secret: "ffae9bf0-6c07-43e8-81c2-863df63529f2",
//   infosec_awareness_lms_clientID: "infosec",
//   infosec_awareness_client_secret: "2115f999-6d51-4d6d-8cae-70896ec3f9c1",
//   staySafeOnline_clientID: "staysafeonline",
//   staySafeOnline_client_secret: "im8hlkYfcOJMu8tJCCgxo7F8o3zQ8fPl",
//   ciso_clientID: "ciso",
//   ciso_client_secret: "OzQ9SZKG5omf2EKuS3KEg0sOWHQtF1tR",
//   // ciso_clientID: "ciso",
//   // ciso_client_secret: "mRQu2TNfFw0lYuOADGfjcDPBpdmtaiRw",
//   ciso_lms_clientID: "ciso_lms",
//   ciso_lms_client_secret: "QASOoSbvJuBpFPepHf5c34KARxGPrOlK",
//   ctf_clientID: "ctf",
//   ctf_client_secret: "8ZTolM1nUQn1j8cbVPwJ5mhAOdqQj2hv",
// };
